import React from 'react'
import classNames from 'classnames'
import Breadcrumbs from '../seo/Breadcrumbs'

import FooterInfos from './footerInfos/FooterInfos'
import FooterTopSearch from './FooterTopSearch'
import FooterCocorico from './FooterCocorico'
import AutoPromoFooterPE from '../autopromo/AutoPromoFooterPE'
import { selectAreGeoentitiesDisplayedAsList } from '../../store/ui/ui.selectors'
import { useSelector } from 'react-redux'
import { selectIsSearchPage } from '../../store/history/history.selectors'
import s from './Footer.less'

const Footer = ({ privacy }) => {
  const isSearchPage = useSelector(selectIsSearchPage)
  const geoentitiesDisplayedAsList = useSelector(selectAreGeoentitiesDisplayedAsList)

  return (
    <div className={classNames(s.footer, isSearchPage && geoentitiesDisplayedAsList && s.withBottomPadding)}>
      <AutoPromoFooterPE />
      <div className={classNames(s.borderBottom, s.detailsSpacing)}>
        <Breadcrumbs />
        <FooterTopSearch />
        <FooterInfos privacy={privacy} />
      </div>
      <FooterCocorico />
    </div>
  )
}

export default Footer
